import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImageNodeView from './imageNodeView.js';

export const ImageExtension = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => (el.getAttribute('data-width') ? Number(el.getAttribute('data-width')) : null),
        renderHTML: (attrs) => (attrs.width ? { 'data-width': attrs.width, style: `width: ${attrs.width}px` } : {}),
      },
      key: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-key') ?? null,
        renderHTML: (attrs) => (attrs.key ? { 'data-key': attrs.key } : {}),
      },
    };
  },
  addCommands() {
    return {
      setImage:
        (options) =>
        ({ chain }) => {
          return chain().insertContent({ type: this.name, attrs: options }).setTextAlign('center').run();
        },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
}).configure({ inline: true, allowBase64: true });
